import React from "react";
import { FunnelModal } from "ui/funnelModal/FunnelModal";
import { Box, Typography } from "@material-ui/core";

const EmptyCatalogMessage: React.FunctionComponent = () => {
  return (
    <FunnelModal size="md" showDividers open>
      <Box textAlign="center" p={10}>
        <Box>
          <Typography variant="h2" color="secondary">
            La page que vous recherchez est malheureusement indisponible
          </Typography>
        </Box>
      </Box>
    </FunnelModal>
  );
};

export default EmptyCatalogMessage;
